let _ = require("underscore");
let Backbone = require("backbone");
let DiscountModel = require("../model/DiscountModel.js");

let main = function (_, Backbone, DiscountModel) {
    return Backbone.Collection.extend({
        model: DiscountModel,
        getValidDiscounts: function () {
            var self = this;
            return _.filter(this.models, function (model) {
                return model.isValid();
            });
        }
    });
};

let exportedValue = main(_, Backbone, DiscountModel);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/collection/DiscountCollection.js